var Events = require('f.core.event');

var __getUrlParams = function() {
    var result = {};
    var params = window.location.search.substring(1).split('&');
    var param;

    for (var i = 0, iLen = params.length; i < iLen; i++) {
        param = params[i].split('=');
        if (param.length == 2) {
            result[param[0]] = decodeURIComponent(param[1]);
        }
    }

    return result;
};

var __urlParams = __getUrlParams();

var formatDatas = function(msg) {
    if (Array.isArray(msg)) {
        return {};
    }
    var items;
    for (var key in msg) {
        items = msg[key];
        items = formatData('danma', items);
    }
    return msg;
};

var formatData = function(type, data) {
    for (var i = 0, iLen = data.length; i < iLen; i++) {
        data[i].__type = type;
    }
    return data;
};

var DataCenter = function(options, message, title) {
    this.cacheIds = {};
    this.datas = {};
    this.message = message;
    this.options = options;
    this.title = title;
    this.init();
};

DataCenter.prototype.init = function() {
    this.initEvent();
    this.initData();
};

DataCenter.prototype.initEvent = function() {
    // this.message.on('gift:list login:list praise:list', function (type, data) {
    //   var data = formatData(type, data);
    //   if (data.length > 0) {
    //     this.trigger('data', type, data);
    //   }
    // }.bind(this));

    var dealData = function(data) {
        var list = formatData(data.type, data.data);
        if (list.length > 0) {
            // list = this.fliteById(list);
            this.trigger('data', data.type, list);
        }
    };

    this.message.on('gift:list', 204, dealData.bind(this));
    this.message.on('online:list', 201, dealData.bind(this));
    this.message.on('praise:list', 201, dealData.bind(this));
};

DataCenter.prototype.fliteById = function(data) {
    var cacheIds = this.cacheIds;
    var result = [];
    var item;
    var now = new Date().valueOf();
    for (var i = 0, iLen = data.length; i < iLen; i++) {
        item = data[i];
        if (typeof item.id == 'undefined') {
            result.push(item);
        } else {
            if (typeof cacheIds[item.id] == 'undefined') {
                cacheIds[item.id] = now;
                result.push(item);
            } else if (now - cacheIds[item.id] > 1 * 60 * 1000 && item.__type == 'online') {
                cacheIds[item.id] = now;
                result.push(item);
            }
        }
    }
    return result;
};

DataCenter.prototype.initData = function() {
    var id = this.options.id;
    var _url = this.options.getPlaybackUrl || '';
    var _urlArray = _url.split(':');
    var _protocol = window.location.protocol == 'http:' ? 'http:' : 'https:';
    this.url = _urlArray[1] ? _protocol + _urlArray[1] : this.options.getPlaybackUrl;

    this.reqData(id);
};

DataCenter.prototype.reqData = function(id) {
    this.datas = {};
    this.options.id = id;
    var data = {
        format: 'jsonp',
    };
    $.ajax({
        url: this.url + id,
        type: 'get',
        dataType: 'jsonp',
        data: data,
        success: function(msg) {
            if (typeof msg.code !== 'undefined' && msg.code !== 1) {
                return;
            }
            this.datas = formatDatas(msg);
            // alert('getRange');
            setTimeout(
                function() {
                    this.getRange(-1, 0);
                }.bind(this),
                300,
            );
        }.bind(this),
    });
};

DataCenter.prototype.getRange = function(begin, end) {
    var result = [];
    var t;
    for (var i = begin + 1; i <= end; i++) {
        t = 't' + i;
        if (this.datas[t]) {
            result = result.concat(this.datas[t]);
        }
    }
    if (result.length > 0) {
        console.log(result);
        // console.log(begin, end, result.map(item => item.id).join('|'));
        // alert(JSON.stringify(result));
        this.trigger('dataMax', 'danma', result);
    }
};

DataCenter.prototype.getData = function(offset) {
    var t = 't' + offset;
    if (this.datas[t]) {
        this.trigger('data', 'danma', this.datas[t]);
    }
};
// {size: "14", position: "middle", color: "0Xfae30c", val: "miaomiaomiao"}
var sendIndex = 0;
DataCenter.prototype.sendData = function(data, offset) {
    // debugger
    var id = this.options.id;
    var _url = this.options.sendUrl || '';
    var _urlArray = _url.split(':');
    var _protocol = window.location.protocol == 'http:' ? 'http:' : 'https:';
    var url = _urlArray[1] ? _protocol + _urlArray[1] : this.options.sendUrl;
    var data = {
        article_id: id,
        title: this.title,
        url:
            window.location.protocol +
            '//' +
            window.location.host +
            window.location.pathname +
            '?liveid=' +
            __urlParams.liveid,
        content: data.val,
        nickname: data.nickname,
        fontsize: data.size,
        offset: offset,
        color: data.color,
        app: 'h5',
        type: 'normal',
        format: 'jsonp',
    };
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'jsonp',
        data: data,
        success: function(msg) {
            data.id = 'sendBack_' + sendIndex++;
            this.trigger('send', [data]);
            console.log(msg);
            // console.log(msg);
            // this.datas = this.datas.concat(msg)
        }.bind(this),
    });
};

Events.mixTo(DataCenter);
module.exports = DataCenter;



// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.compenont.barrage.mobile/app/modules/dataCenter/playback.js